const TITLE = /<title[^>]*>(.*)<\/title[^>]*>/;

export default {
  TITLE,
};
